import { gql } from "@apollo/client"

export const CREATE_DISTRICT_ADMIN = gql`
  mutation createDistrictAdmin($data: CreateDistrictAdminRequest!) {
    districtAdmin {
      create(data: $data)
    }
  }
`

export const UPDATE_DISTRICT_ADMIN = gql`
  mutation updateDistrictAdmin($data: UpdateDistrictAdminRequest!) {
    districtAdmin {
      update(data: $data)
    }
  }
`

export const DELETE_DISTRICT_ADMINS = gql`
  mutation deleteDistrictAdmins($data: DistrictAdminsIdsListRequest) {
    districtAdmin {
      removeBatch(data: $data)
    }
  }
`

export const DISTRICT_ADMIN_SAVE_ONBOARDING = gql`
  mutation saveOnboarding($data: DistrictAdminOnboardingSaveRequest!) {
    districtAdmin {
      saveOnboarding(data: $data)
    }
  }
`
